export type Viewport = { width: number; height: number }
export const getViewport = (): Viewport => ({ width: window.innerWidth, height: window.innerHeight })
